import { BadgeCheck, ShieldCheck } from "lucide-react";

const STYLES = {
  community: { Icon: BadgeCheck, text: "Verified Community", cls: "border-sky-400/60 bg-sky-950/60 text-sky-200" },
  league: { Icon: ShieldCheck, text: "Verified League", cls: "border-amber-400/70 bg-amber-950/60 text-amber-200" },
};

export function VerifiedBadge({ kind, verified, until, compact = false }) {
  if (!verified) return null;
  const { Icon, text, cls } = STYLES[kind];
  return (
    <span title={until ? `${text} until ${new Date(until).toLocaleDateString()}` : text}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${cls}`}
      data-testid={`verified-${kind}-badge`}>
      <Icon className="h-3.5 w-3.5" />{!compact && text}
    </span>
  );
}
